module.exports = __webpack_public_path__ + "static/media/professores.eaab6849.png";